import React, {Component} from "react"
import Layout from "../../../components/Layout"
import FilterMasterData from '../../../components/FilterMasterData';
import leng from "../../../data"

import "./index.scss"

import {
    DataTableSkeleton,
    DataTable,
    TableContainer,
    Table,
    TableHead,
    TableRow,
    TableHeader,
    TableBody,
    TableCell,
    InlineNotification,
    DropdownSkeleton, Pagination, TableToolbarContent, TableToolbarSearch, TableToolbar
} from "carbon-components-react";
import {
    mdata_collections,
    mdata_getBase, mdata_getBaseCount
} from "../../../store/actions/masterData";
import {connect} from "react-redux";
import moment from "moment";
import forEach from "carbon-components-react/lib/components/DatePicker/DatePicker";
import {object} from "prop-types";


const headerData = [/*
    {key: "sku", header: 'Sku'},
    {key: "_lineNumber", header: 'Line File'},
    {key: "urlPath", header: 'Path'},
    {key: "timeStamp", header: 'Creation Date'},
    {key: "Error", header: 'Message'},*/
];
let myObj;
let headersTable = [];
class MasterData extends Component {
    state = {
        primeiraVez: false,
        base: "",
        select: true,
        text: ""
    };

    constructor(props) {
        super(props);
        // this.handleChange = this.handleChange.bind(this);
    }

    async componentDidMount() {
        await this.props.fetchData();
    }


    async onSubmitBase(base, select,text) {
      //console.log(base, select,text);
        this.setState({"base": base, "select": select,text: text})
        await this.props.getBase({"collection": base, skip: 0});
       // await this.props.getBaseCount({"collection": base, "command": "count_documents"});
    }

    async onSubmiSelectBase(selectbase) {
        this.setState({"select": selectbase})
    }

    async onChangePagination(arg1, arg2, arg3) {
        await this.props.getBase({"collection": this.state.base, skip: arg1-1});
    }

    render() {
        let {data, isLoading, dataBase, isLoadingBase, contador} = this.props;
        let rowData = dataBase;
        let filterData = data;
        let headerData = [];
        let contadorTotal = 0;
        //console.log(contador);
        if (typeof contador !== undefined) {
         //   console.log(contador);
            //contadorTotal = contador.count;
        }

        if(filterData.length > 0 && this.state.primeiraVez == false){
            this.setState({primeiraVez: true});
            this.onSubmitBase(filterData[0].collection_name, true,filterData[0].label_name);
            this.setState({"base": filterData[0].collection_name,text: filterData[0].label_name})
                 myObj = filterData.reduce(
                    (acc, { collection_name, ...current }) => Object.assign(acc, {
                        [collection_name]: current.fields
                    }),
                    {}
                );
        }
        if(this.state.base) {

            myObj[this.state.base].forEach((value, index) => {
                let key = Object.keys(value)[0];
                let header = value[Object.keys(value)[0]];
                headerData.push({key: key, header: header});
            })

        }

        rowData =
            dataBase?.length > 0
                ? dataBase.map(execution => {
                    return {
                        ...execution,
                        id: execution._id,
                       /* sortDate: new Date(execution.creationDate),
                        timeStamp: moment(execution.creationDate).format(" DD MMM YYYY hh:mm:ss"),
                        data_v_sku: execution.data_validade_sku ? moment(execution.data_validade_sku).format(" DD MMM YYYY") : " - ",
*/
                    };
                })
                : [];
      //  if (rowData?.length > 0) rowData.sort((a, b) => b.sortDate - a.sortDate);

        return (
            <Layout>
                <div className="section">
                    <div className="section-heading">
                        <br/>
                        <p>{leng.sideBar.repositorio.title}</p>
                        <h1>{leng.sideBar.repositorio.links[1]}</h1>
                        <br/>
                    </div>
                    <div>
                        {isLoading ? (

                            <div className="section-light">
                                <div className="section-light-heading-p0">
                                    <div className="file-upload-container">
                                        <div className="bx--row filter-base">
                                            <div className="bx--col-md-4">
                                                    <DropdownSkeleton />
                                            </div>
                                            <div className="bx--col-md-4">
                                                <DropdownSkeleton />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <div className="section-light">
                                <div className="section-light-heading-p0">
                                    <div className="file-upload-container">
                                        <div className="bx--grid filter-base">
                                            <FilterMasterData data={filterData}
                                                              onSubmitBase={(base, select,text) => this.onSubmitBase(base, select,text)}
                                                              onSubmitSelectBase={(selectBase) => this.onSubmiSelectBase(selectBase)}
                                                              baseSelect={this.state.base}
                                                              basetext={this.state.text}
                                                              select={this.state.select}
                                            />
                                        </div>
                                            <div className="content-tab-produto">
                                                {!isLoadingBase && rowData.length == 0 ? (
                                                    <div>
                                                        <InlineNotification
                                                            lowContrast={true}
                                                            kind="info"
                                                            iconDescription="Info"
                                                            subtitle={<span>No data found</span>}
                                                            title=""
                                                        />
                                                    </div>) : ("")}
                                                {isLoadingBase ? (
                                                    <div className="bx--col-padding  p-2-rem">
                                                        <DataTableSkeleton/>
                                                    </div>
                                                ) : (
                                                    <DataTable
                                                        rows={rowData}
                                                        headers={headerData}>
                                                        {({
                                                              rows,
                                                              headers,
                                                              getHeaderProps,
                                                              getRowProps,
                                                              getTableProps,
                                                              getSelectionProps,
                                                              onInputChange,
                                                          }) => (
                                                            <TableContainer className="upload-table"
                                                                            title={this.state.text}>
                                                                <TableToolbar>
                                                                    <TableToolbarContent>
                                                                    </TableToolbarContent>
                                                                </TableToolbar>
                                                                <Table {...getTableProps()}>
                                                                    <TableHead>
                                                                        <TableRow>
                                                                            {headers.map((header) => (
                                                                                <TableHeader
                                                                                    key={header.key}
                                                                                    {...getHeaderProps({header})}
                                                                                    className="text-center">
                                                                                    {header.header == leng.repositorio.formato_table_header.table[3] ?
                                                                                        <div
                                                                                            className="text-center">{header.header}</div> :
                                                                                        header.header
                                                                                    }

                                                                                </TableHeader>
                                                                            ))}
                                                                        </TableRow>
                                                                    </TableHead>
                                                                    <TableBody>
                                                                        {rows.map((row) => (
                                                                            <TableRow
                                                                                className="upload-row"
                                                                                key={row.id}
                                                                                {...getRowProps({row})}
                                                                            >
                                                                                {row.cells.map((cell) => (
                                                                                    <TableCell
                                                                                        key={cell.id}>
                                                                                        {cell.value}
                                                                                    </TableCell>
                                                                                ))}
                                                                            </TableRow>
                                                                        ))}
                                                                    </TableBody>
                                                                </Table>
                                                                <Pagination
                                                                    className="paginator"
                                                                    totalItems={contadorTotal}
                                                                    pageSizes={[20]}
                                                                    backwardText="Previous"
                                                                    forwardText="Next"
                                                                    PageSize={20}
                                                                    itemsPerPageText={"Items per page"}
                                                                    onChange={(arg1, arg2, arg3) => {
                                                                        this.onChangePagination(arg1, arg2, arg3);
                                                                    }}
                                                                ></Pagination>
                                                            </TableContainer>
                                                        )}
                                                    </DataTable>

                                                )}
                                            </div>


                                    </div>
                                </div>
                            </div>

                        )}
                    </div>
                </div>
            </Layout>
        )
    }
}


const mapStateToProps = ({mdata}) => mdata;

const mapDispatchToProps = dispatch => ({
    fetchData: () => dispatch(mdata_collections()),
    getBase: (params) => dispatch(mdata_getBase(params)),
    getBaseCount: (params) => dispatch(mdata_getBaseCount(params)),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(MasterData);
